import { $, $$ } from '@utils';

function init() {
  if (!$('[data-au-animation-trigger]') || !$('[data-au-animation-target]')) return;

  addEventListeners();
}

/***
 * use:
 * Set this attributes on the data-au-animation-trigger and data-au-animation-target elements
 * The animation is set on the data-au-animation-target that we want
 *
 * data-au-animation-trigger="ID"
 * data-au-animation-target="ID" (we can set this attributes whithout id if data-animation-trigger is contained on data-animation-trigger)
 * data-au-animation-trigger=au-slide-up-fade-out (class set to data-au-animation-target element, on click trigger)
 * data-au-animation-duration=500 (animation duration on ms. 300 by default)
 * data-au-animation-end=au-hide (class set after delay. this delay is the same as animation duration)
 * data-au-animation-timing-function=ease (animation-timing-function. ease by default)
 */
function addEventListeners() {
  $$('[data-au-animation-trigger]').forEach((animationTrigger) => {
    animationTrigger.addEventListener('click', (e) => {
      const target = e.target,
        targetDataSet = target.dataset,
        classNameAtStart = targetDataSet.auAnimationClassname,
        classNameAtEnd = targetDataSet.auAnimationEnd,
        timingFunction = targetDataSet.auAnimationTimingFunction || 'ease',
        delay = targetDataSet.auAnimationDuration || 300,
        isCollapsable = target.dataset.auAnimationClassname.indexOf('collapse') > -1,
        animationTarget =
          target.closest('[data-au-animation-target]') ||
          $(`[data-au-animation-target=${target.dataset.auAnimationTrigger}]`);

      // set height of element to animate it if element to animate is collapsable
      if (isCollapsable) {
        animationTarget.style.height = `${animationTarget.offsetHeight}px`;
      }

      // animation timing function
      animationTarget.style.timingFunction = timingFunction;

      // animation time
      animationTarget.style.animationDuration = `${delay}ms`;

      // init animation
      animationTarget.classList.add(classNameAtStart);

      // end animation
      if (classNameAtEnd) {
        setTimeout(() => {
          animationTarget.classList.remove(classNameAtStart);
          animationTarget.classList.add(classNameAtEnd);
        }, delay);
      }
    });
  });
}

export default { init };
